
import { useNavigate } from 'react-router-dom';

const CTAComunidade = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-luxury-cream py-24 relative">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>

      <div className="container mx-auto px-6 lg:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-gold-500/15 to-gold-600/15 flex items-center justify-center mx-auto mb-8">
            <i className="ri-quill-pen-fill text-gold-600 text-3xl"></i>
          </div>

          <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-luxury-charcoal mb-6 leading-tight">
            Ainda não escreveu<br />
            <span className="italic text-gold-600">sua carta?</span>
          </h2>

          <p className="font-['Montserrat'] text-sm text-luxury-charcoal/40 max-w-md mx-auto mb-10 font-light tracking-wide leading-relaxed">
            Comece agora mesmo sua jornada de autoconhecimento. Escreva uma carta para o seu eu do futuro e faça parte dessa comunidade transformadora.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="group bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-['Montserrat'] font-semibold text-sm px-10 py-4 rounded-lg hover:shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all duration-500 hover:scale-105 flex items-center gap-3 whitespace-nowrap cursor-pointer tracking-wider uppercase"
            >
              Escrever Minha Carta
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-2 transition-transform duration-300"></i>
            </button>

            <button
              onClick={() => navigate('/dashboard')}
              className="font-['Montserrat'] text-sm text-gold-700 border border-gold-500/30 px-8 py-4 rounded-lg hover:bg-gold-500/10 transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wider uppercase"
            >
              Ver Minhas Cartas
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTAComunidade;
